import {PageField} from '../forms/interfaces/page-field';
import {FormFieldPrefillOption} from '../enums/form-field-prefill-option.enum';

export function fieldsContainPatientInformation(fields: PageField[]): boolean {
  return !!fields.find((field) => [
    FormFieldPrefillOption.PATIENT_PMS_ID, 
    FormFieldPrefillOption.PATIENT_NAME, 
    FormFieldPrefillOption.PRACTICE_NAME, 
    FormFieldPrefillOption.PATIENT_AGE, 
    FormFieldPrefillOption.PATIENT_BREED,
    FormFieldPrefillOption.PATIENT_SEX,
    FormFieldPrefillOption.PATIENT_SPECIES,
  ].includes(field.prefillWith));
}
